import React from 'react';
import { Controller } from 'react-hook-form';
import { MenuItem, TextField } from '@material-ui/core';

export function Select({
  control,
  name,
  controllerProps = {},
  options,
  ...rest
}) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        if (options?.length && options?.length > 0) {
          return (
            <TextField
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              defaultValue=""
              {...field}
              {...rest}
              select
              value={field?.value ?? ''}
            >
              {options?.length > 0 ? (
                options.map((option) => (
                  <MenuItem
                    key={option?.value ?? option?.id}
                    value={option?.value ?? option?.id}
                  >
                    {option?.label ?? option?.nome}
                  </MenuItem>
                ))
              ) : (
                <MenuItem key="" value="">
                  Nenhuma opção
                </MenuItem>
              )}
            </TextField>
          );
        }

        return null;
      }}
      {...controllerProps}
    />
  );
}

export default Select;
